import { SearchCompletion } from './search-completion';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { Injectable, EventEmitter } from '@angular/core';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SearchService {
  private searchStrings = new Map<string, BehaviorSubject<string | null>>();
  private all$ = new BehaviorSubject<string | null>(null);
  private currentClient = '';
  private _toggleSearch = new EventEmitter();
  private _completionOptions$ = new Subject<SearchCompletion[]>();

  get enableSearch() {
    return (
      this.currentClient !== '' &&
      !!this.searchStrings.get(this.currentClient) &&
      this.searchStrings.get(this.currentClient)!.observers.length > 0
    );
  }

  public get completionOptions$() {
    return this._completionOptions$.asObservable();
  }

  public get toggleSearch$(): Observable<any> {
    return this._toggleSearch;
  }
  public search(str: string) {
    this.all$.next(str);
    this.searchStrings.get(this.currentClient)?.next(str);
  }

  public setCompletion(value: SearchCompletion[]) {
    this._completionOptions$.next(value);
  }
  public toggleSearch() {
    this._toggleSearch.emit();
  }

  public registerSearchClient(subscriberId: string): Observable<string | null> {
    if (subscriberId !== 'all') {
      this.currentClient = subscriberId;
    } else {
      return this.all$.asObservable();
    }

    if (!this.searchStrings.get(this.currentClient)) {
      this.searchStrings.set(
        this.currentClient,
        new BehaviorSubject<string | null>(null)
      );
    } else {
      this.all$.next(this.searchStrings.get(this.currentClient)!.getValue());
    }

    return this.searchStrings
      .get(this.currentClient)!
      .asObservable()
      .pipe(finalize(() => this.all$.next('')));
  }

  public focusClient(subscriberId: string) {
    this.currentClient = subscriberId;
  }
}
